import { makeStyles } from "@material-ui/core/styles";

export const addPaymentSideBarCss = makeStyles(() => ({

    titleV1: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: 1.5,
        color: 'rgba(11, 19, 35, 0.5)'
    },
    titleV2: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: 1.5,
        textAlign: 'right',
        color: 'rgba(11, 19, 35, 0.5)'
    },
    textV1: {
        fontSize: '16px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        marginTop: 4
    },
    textV2: {
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323',
        marginTop: 4
    },
    gridContainer: {
        padding: '16px 24px',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    mtV1: {
        marginTop: 30
    },
    formTitle: {
        fontSize: '12px',
        fontWeight: 300,
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    mtV2: {
        marginTop: 8
    },
    mtV3: {
        marginTop: 24
    },
    mtV4: {
        marginTop: 4
    },
    gridItemStatus: {
        marginTop: 4,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'flex-end'
    },
    checkboxInput: {
        width: '100%'
    },
    dotV1: {
        fontSize: 6,
        color: '#c4c4c4',
        marginLeft: 8,
        marginRight: 8
    },
    gridParam: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 4,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)',
    },
    divBox: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#c6d4ff',
        fontSize: '10px',
        color: '#0033cc',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    divBoxPart: {
        padding: '2px 4px',
        borderRadius: '2px',
        backgroundColor: '#ffdbc1',
        fontSize: '10px',
        color: '#e8843c',
        width: 'fit-content',
        letterSpacing: '0.05em',
        fontWeight: 'bold'
    },
    checkboxTripLabel: {
        height: '100%',
        minHeight: 78,
        maxHeight: 100,
        backgroundColor: 'white',
        borderRadius: 8,
        marginLeft: 0,
        marginRight: 0,
        width: '100%',
        paddingTop: 16,
        paddingBottom: 16,
        paddingRight: 16,
        paddingLeft: 15,
        marginBottom: '12px',
        '& .MuiFormControlLabel-label': {
            width: '100%'
        }
    },
    containerWidth: {
        width: 'fit-content'
    },
    containerWidthV1: {
        width: '180px'
    },
    gridRoute: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
        overflowWrap: 'break-word'
    },
    tripBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    cardInput: {
        backgroundColor: 'white',
        marginLeft: '0.5em',
        width: 86,
        '& .MuiOutlinedInput-input': {
            paddingTop: 1,
            paddingBottom: 1,
            paddingRight: '3px !important'
        }
    },
    divAlign: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0033cc'
    },
    divAlignV1: {
        display: 'flex',
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#e8843c'
    },
    closeIconV1: {
        color: '#D0D0D0',
        fontSize: 20
    },
    divAlignTitle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%'
    },
    dialogContentV1: {
        paddingTop: 24,
        paddingBottom: '24px !important',
        paddingLeft: 30,
        paddingRight: 30,
        backgroundColor: '#f6f6f8'
    },
    dialogV1: {
        borderRadius: '8px !important'
    },
    dialogTitleV1: {
        paddingLeft: 30,
        paddingTop: 8,
        paddingBottom: '8px !important',
        paddingRight: 12
    },
    dialogActionsV1: {
        paddingTop: 20,
        paddingBottom: '20px !important',
        paddingRight: 30,
        paddingLeft: 30
    },
    closeButton: {
        borderRadius: '4px !important',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        border: 'solid 1px #d8dce6',
        background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        paddingLeft: 20,
        paddingRight: 20,
        paddingTop: 6,
        paddingBottom: 6,
        fontSize: '14px',
        fontWeight: 300,
        lineHeight: 1.43,
        letterSpacing: 'normal',
        color: '#3e3f42',
        textTransform: 'none',
        '&:hover': {
            background: 'linear-gradient(to top, #f6f7f9, #ffffff)',
        }
    },
    saveButton: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#09101e',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#ffffff',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#09101e'
        }
    },
    saveButtonDisabled: {
        padding: '6px 24px',
        borderRadius: '4px',
        backgroundColor: '#dadada',
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.71,
        letterSpacing: 'normal',
        color: '#5e636c',
        textTransform: 'none',
        boxShadow: '0 1px 1px 0 rgba(22, 29, 37, 0.05), inset 0 2px 0 0 rgba(255, 255, 255, 0.05) !important',
        marginLeft: '16px !important',
        '&:hover': {
            backgroundColor: '#dadada'
        }
    },
    gridContainerDialog: {
        padding: '16px !important',
        borderRadius: '8px',
        border: 'solid 1px #dcdcdc',
        backgroundColor: '#ededed'
    },
    gridParamsDialog: {
        display: 'flex',
        alignItems: 'center',
        marginTop: 2,
        fontSize: '12px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: '#0b1323',
    },
    dotV2: {
        fontSize: '6px !important',
        color: '#c4c4c4',
        marginLeft: 4,
        marginRight: 6
    },
    gridRouteDialog: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: '#0b1323'
    },
    textBalance: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        textAlign: 'right',
        color: '#0b1323'
    },
    titleV3: {
        fontSize: '14px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: 'normal',
        textAlign: 'left',
        color: 'rgba(11, 19, 35, 0.75)'
    },
    textFieldV1: {
        '& .MuiOutlinedInput-root': {
            backgroundColor: 'white',
            color: '#0b1323'
        }
    },
    textFieldV2: {
        backgroundColor: 'white'
    },
    gridItemV1: {
        display: 'flex'
    },
    marginV1: {
        marginLeft: 6,
        marginRight: 6
    },
    checkBoxLabel: {
        fontSize: '16px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        marginBottom: 8
    },
    mtV5: {
        marginTop: 24
    },
    gridTitleDialog: {
        fontSize: '12px',
        fontWeight: 300,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.5,
        letterSpacing: 'normal',
        color: 'rgba(11, 19, 35, 0.75)',
        paddingLeft: 8,
        paddingRight: 8,
        marginBottom: 8
    },
    divAmountContainer: {
        marginTop: 24
    },
    widthV1: {
        maxWidth: '420px !important',
        width:'100%'
    },
    checkBoxChecked: {
        color: 'transparent !important'
    },
    mlV1: {
        marginLeft: 24
    },
    divTitle: {
        fontSize: 20,
        fontWeight: 300
    },
    errorV1: {
        fontSize: 16,
        color: '#ff1744',
        marginBottom: 8
    },
    partyListItem: {
        padding: '12px 15px',
        minHeight: 46,
        margin: 0,
        maxHeight: 46,
        width: '100%'
    },
    titleBullet: {
        borderRadius: "50%",
        backgroundColor: "lightgrey",
        fontSize: 8,
        color: "lightgrey",
        margin: "0px 6px",
        marginTop: -2
    },
    partyAddListItem: {
        padding: '12px 15px',
        margin: 0,
        backgroundColor: '#e3e8fd',
        color: '#0033cc',
        // fontWeight: 300,
        minHeight: 46,
        width: '100%',
        maxHeight: 46
    },
    addPersonIcon: {
        color: '#0033cc',
        marginRight: 10
    },
    cherveRightIcon: {
        marginLeft: 10,
        float: 'right',
        color: '#0033cc'
    },
    listBoxAutoCompelete: {
        margin: 0,
        padding: 0
    },
    listBoxOption: {
        padding: 0,
        minHeight: 46,
        maxHeight: 46,
        borderBottom: '1px solid #eaedf3',
        "&:first-child": {
        },
        "&:last-child": {
        }
    },
    autoCompleteField: {
        backgroundColor: 'white !important'
    },
    switchLabel: {
        marginLeft: 0
    },
    switch: {
        marginLeft: 5,
        '& .MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#0033cc'
        },
        '& .MuiSwitch-colorSecondary.Mui-checked': {
            color: '#0033cc'
        }
    },
    eventIcon: {
        color: 'grey'
    }

}))